import { render, staticRenderFns } from "./MediaUpload.vue?vue&type=template&id=b0b98566&scoped=true"
import script from "./MediaUpload.vue?vue&type=script&lang=ts"
export * from "./MediaUpload.vue?vue&type=script&lang=ts"
import style0 from "./MediaUpload.vue?vue&type=style&index=0&id=b0b98566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b98566",
  null
  
)

export default component.exports